import { capitalizeFirstLetter } from '@utils/capitalizeFirstLetter';

/**
 * Words that should remain lowercase when capitalizing basket item labels.
 * Extend this set to add more exceptions.
 *
 * Examples:
 * - "gas and electricity" → "Gas and Electricity"
 * - "unlimited max sim x3" → "Unlimited Max SIM x3"
 * - "uw wi-fi hub pro" → "UW Wi-Fi Hub Pro"
 */
const CONJUNCTIONS = new Set(['and', 'or']);
const QUANTITY_SIM_MULTIPLIER = /^x\d+$/i;
const ACRONYMS = new Set(['uw']);

const capitalizeWord = (word: string): string => {
  if (
    CONJUNCTIONS.has(word.toLowerCase()) ||
    QUANTITY_SIM_MULTIPLIER.test(word)
  ) {
    return word.toLowerCase();
  }

  if (ACRONYMS.has(word.toLowerCase())) {
    return word.toUpperCase();
  }

  if (word.includes('-')) {
    return word
      .split('-')
      .map((part) => capitalizeFirstLetter(part))
      .join('-');
  }

  return capitalizeFirstLetter(word);
};

export const capitalizeLabel = (text: string): string =>
  text.split(' ').map(capitalizeWord).join(' ');
